var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 15,
    rx: 2,
    fill: "#1F72CD",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1443 5.62036L2 10.576H4.56703L4.88527 9.78586H5.61269L5.93093 10.576H8.75651V9.97294L9.00828 10.576H10.4699L10.7217 9.9602V10.576H16.5981L17.3127 9.80638L17.9817 10.576L21 10.5824L18.8489 8.11201L21 5.62036H18.0285L17.333 6.37575L16.685 5.62036H10.2922L9.74322 6.89945L9.18139 5.62036H6.61972V6.2029L6.33475 5.62036H4.1443ZM12.9196 6.32407H16.2941L17.3262 7.48836L18.3916 6.32407H19.4237L17.8555 8.11131L19.4237 9.87796H18.3448L17.3127 8.70015L16.2419 9.87796H12.9196V6.32407ZM13.7529 7.70948V7.06034V7.05972H15.8585L16.7773 8.09787L15.8178 9.14169H13.7529V8.43301H15.5939V7.70948H13.7529ZM4.64098 6.32407H5.89227L7.31459 9.68451V6.32407H8.68533L9.7839 8.73349L10.7964 6.32407H12.1603V9.88006H11.3304L11.3236 7.09361L10.1137 9.88006H9.3713L8.15461 7.09361V9.88006H6.44733L6.12366 9.08285H4.37499L4.05199 9.87936H3.13725L4.64098 6.32407ZM4.67359 8.34589L5.2497 6.92573L5.82515 8.34589H4.67359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanIcon);
export default __webpack_public_path__ + "static/media/American_icon.600e74cebc22d4c1e7fd74da3f169a04.svg";
export { ForwardRef as ReactComponent };